import * as React from "react"
import { uniqueId } from "lodash"

const FlagEn = (props: React.SVGAttributes<SVGElement>) => {
  const id = uniqueId("flagen")

  return (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <title>UK-flag</title>
      <defs>
        <circle id={`path-1-${id}`} cx="11" cy="11" r="11" />
        <circle id={`path-3-${id}`} cx="11" cy="11" r="11" />
      </defs>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(-21.000000, -20.000000)">
          <g transform="translate(22.000000, 21.000000)">
            <mask id={`mask-2-${id}`} fill="white">
              <use xlinkHref={`#path-1-${id}`} />
            </mask>
            <use stroke="#FFFFFF" strokeWidth="2" fill="#1E2F9D" xlinkHref={`#path-1-${id}`} />
            <mask id={`mask-4-${id}`} fill="white">
              <use xlinkHref={`#path-3-${id}`} />
            </mask>
            <use fill="#1E2F9D" xlinkHref={`#path-3-${id}`} />
            <rect
              fill="#FFFFFF"
              mask={`url(#mask-4-${id})`}
              transform="translate(12.146447, 11.646447) rotate(-315.000000) translate(-12.146447, -11.646447) "
              x="11.1464466"
              y="-2.35355339"
              width="2"
              height="28"
            />
            <rect
              fill="#DA3535"
              mask={`url(#mask-4-${id})`}
              transform="translate(11.500000, 11.000000) rotate(-315.000000) translate(-11.500000, -11.000000) "
              x="11"
              y="-3"
              width="1"
              height="28"
            />
            <rect
              fill="#FFFFFF"
              mask={`url(#mask-4-${id})`}
              transform="translate(10.146447, 11.646447) rotate(-45.000000) translate(-10.146447, -11.646447) "
              x="9.14644661"
              y="-2.35355339"
              width="2"
              height="28"
            />
            <rect
              fill="#DA3535"
              mask={`url(#mask-4-${id})`}
              transform="translate(11.500000, 11.000000) rotate(-45.000000) translate(-11.500000, -11.000000) "
              x="11"
              y="-3"
              width="1"
              height="28"
            />
            <rect fill="#FFFFFF" mask={`url(#mask-4-${id})`} x="13" y="-3" width="1" height="28" />
            <rect fill="#FFFFFF" mask={`url(#mask-4-${id})`} x="8" y="-3" width="1" height="28" />
            <rect
              fill="#DA3535"
              mask={`url(#mask-4-${id})`}
              transform="translate(11.500000, 11.000000) rotate(-270.000000) translate(-11.500000, -11.000000) "
              x="10"
              y="-3"
              width="3"
              height="28"
            />
            <rect
              fill="#FFFFFF"
              mask={`url(#mask-4-${id})`}
              transform="translate(11.500000, 13.000000) rotate(-270.000000) translate(-11.500000, -13.000000) "
              x="11"
              y="-1"
              width="1"
              height="28"
            />
            <rect
              fill="#FFFFFF"
              mask={`url(#mask-4-${id})`}
              transform="translate(11.500000, 9.000000) rotate(-270.000000) translate(-11.500000, -9.000000) "
              x="11"
              y="-5"
              width="1"
              height="28"
            />
            <rect fill="#DA3535" mask={`url(#mask-4-${id})`} x="9" y="-3" width="4" height="28" />
          </g>
        </g>
      </g>
    </svg>
  )
}

export default FlagEn
